import React from 'react';
import { LockIcon } from 'lucide-react';
import { Carousel } from './ui/Carousel';
import { CtaButton } from './ui/CtaButton';
import { previewPages, lockedPageImage } from '../data/content';
export function PreviewSection() {
  return <section className="grid-bg w-full bg-night px-5 pb-12 pt-12" aria-labelledby="preview-titulo" data-id="element-146" data-mp="223h82lxx1zxl">
      <div className="mx-auto max-w-5xl" data-id="element-147" data-mp="271irx93623a4">
        <h2 id="preview-titulo" className="text-center font-display text-2xl font-bold leading-snug text-cream md:text-4xl" data-id="element-148" data-mp="1sefuf2eufums">
          Mira por dentro la guía <span className="text-gold" data-id="element-149" data-mp="1x6quq6dhxifv">Geografía Bíblica 3D</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-cream-dim md:text-lg" data-id="element-150" data-mp="1jf2gnxjosjw9">
          Recorre páginas reales del material y observa la calidad visual de los mapas, las imágenes 3D y las
          explicaciones bíblicas antes de desbloquear la guía completa.
        </p>

        <div className="mt-12" data-id="element-151" data-mp="1edmv84dlkbdc">
          <Carousel label="Páginas de muestra" itemClassName="w-[78%] sm:w-[46%] lg:w-[31%]" data-id="element-152" data-mp="2crrbaj3usjzq">
            {[...previewPages.map((page, index) => <figure key={page.src} className="h-full overflow-hidden rounded-xl border border-night-line bg-night-card" data-id="element-153" data-mp="27sn05mxdcc6r" data-mpi={index}>
                  <img src={page.src} alt={`Página de muestra — ${page.caption}`} className="w-full" loading="lazy" data-id="element-154" data-mp="2guw9waktc1j3" />
                  <figcaption className="px-4 py-3 text-xs text-cream-dim" data-id="element-155" data-mp="1t4a46pya6tc9">Muestra {index + 1}</figcaption>
                </figure>), <figure key="locked" className="relative h-full overflow-hidden rounded-xl border border-gold/40 bg-night-card" data-id="element-156" data-mp="22ud8hmaurtpw">
                <img src={lockedPageImage} alt="Página bloqueada" className="w-full opacity-40" loading="lazy" data-id="element-157" data-mp="1adiz40lbtp3o" />
                <figcaption className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-night-deep/70 px-6 text-center" data-id="element-158" data-mp="15epihzaqthza">
                  <LockIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-159" data-mp="35fw5vr7e2484" />
                  <span className="font-display text-base font-bold text-cream" data-id="element-160" data-mp="3af0d4car5rvt">
                    +100 estudios visuales completos te esperan
                  </span>
                  <span className="text-xs text-cream-dim" data-id="element-161" data-mp="3k5licikxlunp">
                    Mapas 3D, rutas bíblicas, ciudades antiguas, contextos históricos y explicaciones visuales.
                  </span>
                </figcaption>
              </figure>]}
          </Carousel>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-sm leading-relaxed text-cream-dim md:text-base" data-id="element-162" data-mp="2wg0qfa6svn2a">
          Estas son solo algunas páginas de muestra. La guía completa reúne más de 50 estudios visuales con mapas,
          imágenes realistas y explicaciones bíblicas organizadas para facilitar tu comprensión.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-163" data-mp="fqc1pf2k60wh">
          <CtaButton data-id="element-164" data-mp="ft8177u20xn1">Quiero acceder a los mapas 3D</CtaButton>
        </div>
      </div>
    </section>;
}